export default "__VITE_PUBLIC_ASSET__1332c864__"